module.exports = __webpack_public_path__ + "img/Ko-studio.01eef125.gif";